import { render, staticRenderFns } from "./DiscountedInternetOfferTile.vue?vue&type=template&id=07b2d000&scoped=true&"
import script from "./DiscountedInternetOfferTile.vue?vue&type=script&lang=js&"
export * from "./DiscountedInternetOfferTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b2d000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b2d000')) {
      api.createRecord('07b2d000', component.options)
    } else {
      api.reload('07b2d000', component.options)
    }
    module.hot.accept("./DiscountedInternetOfferTile.vue?vue&type=template&id=07b2d000&scoped=true&", function () {
      api.rerender('07b2d000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/DiscountedInternetOfferTile.vue"
export default component.exports